const css = `.ZcXy8a__titleBar{background-color:#2e81dd}.ZcXy8a__avatar{height:80px;width:80px;background:var(--base-surfaces-default);border-radius:48px;display:inline-block;position:absolute;top:60px;right:22px;box-shadow:0 0 6px #0000003b}.ZcXy8a__headerContainer{z-index:10;position:sticky;top:0}`;
document.head
    .appendChild(document.createElement("style"))
    .appendChild(document.createTextNode(css));
export {css};

export default {"titleBar":"ZcXy8a__titleBar","avatar":"ZcXy8a__avatar","headerContainer":"ZcXy8a__headerContainer"};
